import React, { useRef, useEffect, useState } from "react";
import {
  FaTools,
  FaIndustry,
  FaCogs,
  FaShip,
  FaHome,
  FaChair,
} from "react-icons/fa";

// Industries data
const industries = [
  {
    icon: <FaTools className="text-2xl md:text-3xl lg:text-4xl mb-2" />,
    title: "Construction",
    desc: "Heavy-duty solutions for building projects",
  },
  {
    icon: <FaHome className="text-2xl md:text-3xl lg:text-4xl mb-2" />,
    title: "Architecture",
    desc: "We provide stylish and functional hinge options.",
  },
  {
    icon: <FaIndustry className="text-2xl md:text-3xl lg:text-4xl mb-2" />,
    title: "Industrial",
    desc: "Our products ensure safety and durability on the road.",
  },
  {
    icon: <FaShip className="text-2xl md:text-3xl lg:text-4xl mb-2" />,
    title: "Marine & Offshore",
    desc: "Our hinges are engineered for structural integrity.",
  },
  {
    icon: <FaCogs className="text-2xl md:text-3xl lg:text-4xl mb-2" />,
    title: "Infrastructure",
    desc: "We provide stylish and functional hinge options.",
  },
  {
    icon: <FaChair className="text-2xl md:text-3xl lg:text-4xl mb-2" />,
    title: "Furniture & Interiors",
    desc: "Our products ensure safety and durability on the road.",
  },
];

// Stats data
const stats = [
  { value: 100, suffix: "+", label: "Projects Completed" },
  { value: 18, suffix: "+", label: "States Served" },
  { value: 25, suffix: "+", label: "Industry Sectors" },
  { value: 99, suffix: "%", label: "Client Satisfaction" },
];

// StatItem with animation
const StatItem = ({ value, suffix, label }) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          let start = 0;
          const duration = 1000;
          const step = Math.max(duration / value, 20);
          const counter = setInterval(() => {
            start++;
            setCount(start);
            if (start >= value) {
              clearInterval(counter);
              setHasAnimated(true);
            }
          }, step);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [hasAnimated, value]);

  return (
    <div className="text-center md:text-left mb-4 md:mb-0" ref={ref}>
      <p className="text-3xl font-bold text-blue-600">
        {count}
        {suffix}
      </p>
      <p className="text-gray-600">{label}</p>
    </div>
  );
};

const IndustriesSection = () => {
  return (
    <section className="py-7 mt-[13%] md:mt-[8%] lg:mt-[5%] pb-0 px-4 md:px-10 bg-white">
      <h2 className="text-3xl text-shadow md:text-4xl Manrope font-bold ms-5 mb-5">
        Explore the Industries We Serve
      </h2>

      {/* Industries */}
      <div className="flex flex-wrap">
        {industries.map((item, index) => (
          <div
            key={index}
            className={`w-full md:w-1/3 p-6 mb-7 border-gray-300 ${
              index % 3 !== 2 ? "md:border-r" : ""
            }`}
          >
            <div className="text-black">
              {item.icon}
              <h4 className="md:text-3xl lg:text-4xl text-2xl font-semibold mb-1">
                {item.title}
              </h4>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Animated Stats */}
      <div className="flex justify-center items-center">
        <div className="rounded-lg p-6 md:flex md:justify-between md:space-x-4 bg-gray-50 mt-5 md:mt-20 lg:min-w-[60rem] max-w-[80rem]">
          {stats.map((stat, i) => (
            <StatItem
              key={i}
              value={stat.value}
              suffix={stat.suffix}
              label={stat.label}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
